import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`HostJane is also serious about stopping anyone denying the Holocaust happened or threatening the sanctity of Anne Frank's memory using the HostJane platform.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      